import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["confirmationStep", "otpStep"];

  showOtpField() {
    this.confirmationStepTarget.classList.add("hidden");
    this.otpStepTarget.classList.remove("hidden");

    const otpInput = this.otpStepTarget.querySelector(
      'input[name*="otp_attempt"]'
    );
    if (otpInput) {
      otpInput.focus();
    }
  }
}
